module.exports = __webpack_public_path__ + "static/media/robertCrew45.da4df89d.png";